import { useEffect, useMemo } from 'react'
import { useOrganizationServiceGetByDomainQuery } from 'zma-react-sdk/organization-service'
import { useAppStore } from '@/stores/appStore'

export default function OrgBootstrapper() {
  const { setOrganization, setIsLoading } = useAppStore()

  const domain = useMemo(() => {
    try {
      return window.location.hostname || ''
    } catch {
      return ''
    }
  }, [])

  const { data, loading, error } = useOrganizationServiceGetByDomainQuery({
    variables: { domain },
    skip: !domain,
    context: { suppressGraphQLErrors: true },
    // fetchPolicy inherits defaults from ApolloClient
  })

  useEffect(() => {
    setIsLoading(loading)
  }, [loading, setIsLoading])

  useEffect(() => {
    if (data?.organizationServiceGetByDomain) {
      setOrganization(data.organizationServiceGetByDomain)
    } else if (!loading && (error || !domain)) {
      setOrganization(null)
    }
  }, [data, loading, error, domain, setOrganization])

  return null
}
